import { render, staticRenderFns } from "./Bottoniera.vue?vue&type=template&id=b01315b2&scoped=true&"
import script from "./Bottoniera.vue?vue&type=script&lang=js&"
export * from "./Bottoniera.vue?vue&type=script&lang=js&"
import style0 from "./Bottoniera.vue?vue&type=style&index=0&id=b01315b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01315b2",
  null
  
)

export default component.exports